import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export type DataMappingType = "Lettering" | "Color" | "Display";
export type DesignElementType = "Lettering" | "Color" | "Design";

export const DesignElementToDataMappingType: Record<
  DesignElementType,
  DataMappingType
> = {
  Lettering: "Lettering",
  Color: "Color",
  Design: "Display",
};

const DATA_MAPPING_TYPES = ["none", "Lettering", "Color", "Display"];

type SelectDataMappingTypeProps = {
  isDisabled?: boolean;
};

export const SelectDataMappingType: React.FC<SelectDataMappingTypeProps> = ({
  isDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <SelectField
      name="config_type"
      label={t("dataMappings.form.label.type")}
      style={{ width: "100%" }}
      options={DATA_MAPPING_TYPES.map((typeId) => ({
        label: t(`dataMappings.types.${typeId}`),
        value: typeId,
      }))}
      disabled={isDisabled}
    />
  );
};
